import { SelectOption } from '../../components/common/Select';

export const findOptionLabelByValue = (options: SelectOption[], value: SelectOption['value']) => {
  const matchItem = options.find(option => option.value === value);
  return matchItem ? matchItem.label : undefined;
};
